import React from 'react';
import Icon from 'components/Icon';
import './upload.less';

export default class UploadNarrow extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { visible, changeNarrowVisible } = this.props;
        if (!visible) {
            return null;
        }
        return (
            <div className="material-upload-narrow">
                <div className="narrow-text-tip">{window.language['conmmon.upload.progress']}</div>
                <div className="narrow-icon" onClick={() => { changeNarrowVisible() }}>
                    <Icon className="add-circle-o" />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Upload/UploadNarrow.js